import React from "react";
import {observer} from "mobx-react";
import FeaturesStore from "./FeaturesStore";
import AppNavigator from "./navigator/AppNavigator";
import {StandardLayout} from "./layout/StandardLayout";
import SessionStore from "../../services/session/SessionStore";
import applyRouteAccessControl from "./site/applyRouteAccessControl";
import appRoutesList from "./site/appRoutesList";
import tabsOrientedDefaultSiteMap from "./site/sitemaps/tabsOrientedDefaultSiteMap";
import foldyDefaultSiteMap from "./site/sitemaps/foldyDefaultSiteMap";
import foldySettingsSiteMap from "./site/sitemaps/foldySettingsSiteMap";
import foldyDemoSitemap from "./site/sitemaps/foldyDemoSitemap";
import FullPageSpinner from "../../services/session/components/FullPageSpinner";
import {getItem} from "../../services/storage/localStorage";
import {FoldyContextProvider, FoldyLayout} from './layout/FoldyLayout';
import { billingAdminSiteMap } from '../admin';
import BrandConfigStore from "../../services/config/BrandConfigStore";

const AppRoutes = observer(props => {
  if (!SessionStore.sessionLoaded) {
    return <FullPageSpinner />
  } else if (!BrandConfigStore.brandConfig.restrictions.hideNewUiOptIn) {
    return <AppNavigator
      key="foldy-layout"
      siteMapTemplate={foldyDefaultSiteMap}
      secondarySiteMaps={[
        foldySettingsSiteMap,
        billingAdminSiteMap,
        foldyDemoSitemap
      ]}
      routes={applyRouteAccessControl(appRoutesList)}
      Layout={FoldyLayout}
      LayoutContextProvider={FoldyContextProvider}
      defaultUrl={resolveTabToRedirectTo()}
    />
  } else {

    return <AppNavigator
      key="standard-layout"
      siteMapTemplate={tabsOrientedDefaultSiteMap}
      routes={applyRouteAccessControl(appRoutesList)}
      Layout={StandardLayout}
      defaultUrl={resolveTabToRedirectTo()}
    />
  }
});

function resolveTabToRedirectTo() {
  const shouldRestore = (SessionStore.userPreferences && SessionStore.userPreferences.stickyUrl) || false;
  const userId = SessionStore.user.userId;
  const firstTab = FeaturesStore.firstEnabledRoute();

  if (shouldRestore) {
    const maybeStoredLocation = getItem(`RESTORE_URL_${userId}`);
    if (!!maybeStoredLocation) {
      const redirect = JSON.parse(maybeStoredLocation).hash;
      if (!!redirect && redirect !== "#/")
        return redirect.charAt(0) === "#" ? redirect.substring(1) : redirect;
    }
  }
  return firstTab
}

export default AppRoutes;
